const paths = {
  listAgent: '/agent/list',
  editAgent: '/agent/edit'
};

export default paths;
